const LOW_USAGE_RATIO = 0.8;

export function parseLicenseLimit(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.trunc(n);
}

export function parseLicenseUsage(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.trunc(n);
}

/** @returns {{ used: number, max: number|null, ratio: number|null, isLow: boolean, isAtLimit: boolean }} */
export function getLicenseUsageMetric(usedRaw, maxRaw) {
  const used = parseLicenseUsage(usedRaw);
  const max = parseLicenseLimit(maxRaw);

  if (max == null) {
    return { used, max: null, ratio: null, isLow: false, isAtLimit: false };
  }

  const ratio = max > 0 ? used / max : 1;
  const isAtLimit = used >= max;
  const isLow = !isAtLimit && ratio >= LOW_USAGE_RATIO;

  return { used, max, ratio, isLow, isAtLimit };
}

export function isLicenseActive(activeLicense) {
  if (!activeLicense) return false;
  return String(activeLicense.is_active ?? 'true') !== 'false';
}

export function getLicenseLimitBannerVariant(user) {
  const license = user?.activeLicense;
  if (!license || !isLicenseActive(license)) {
    return { kind: 'no_license' };
  }

  const docs = getLicenseUsageMetric(
    license.documents_generated,
    license.max_documents
  );
  const sigs = getLicenseUsageMetric(
    license.documents_signed,
    license.max_signatures
  );

  if (docs.isAtLimit || sigs.isAtLimit) {
    return { kind: 'at_limit', docs, sigs };
  }
  if (docs.isLow || sigs.isLow) {
    return { kind: 'low', docs, sigs };
  }
  return null;
}
